angular.module('onsite')
    .filter('phone', function() {
        return function(input, showCountryCode) {

            if(input && input.length >= 10) {
                if(input.length === 12){
                    var countryCode = input.substring(0, 2);
                    input = input.substring(2);
                }

                var areaCode = input.substring(0, 3);
                var prefix = input.substring(3, 6);
                var suffix = input.substring(6, 10);

                var out = "(" + areaCode + ") " + prefix + "-" + suffix;

                return (showCountryCode && countryCode) ? countryCode + " " + out : out;
            }

            return input;
        };
    });
